// 在庫表示の新旧比較プレビュー（Issue #31 の検証用。切り替えが済んだら消す）。
//
// 商品ページの URL に `?wu_stock_preview=1` が付いているときだけ、新 API
// （front.workup-system.com/api/stock-check）の HTML を、旧コード（wuSiteResource2 の checkStockRSP*）が
// 差し込む `.stockInfo` の**直後**にラベル付きで並べる。クエリが無ければ何もしないので顧客には見えない。
//
// 旧側の後ろに置くのは、setupStockLimit と #zk-inq がどちらも querySelector で**最初の** .stockInfo を
// 見るため。カート制御と「表示以上の枚数〜」ボタンは旧側のまま動く。
// 旧側が出ないページ（予約購入 #wu-reserve、在庫非表示など）では、旧の差し込み先と同じ場所に新だけ置く
// （新も空なら何も出ない）。

const API = 'https://front.workup-system.com/api/stock-check'
export const PREVIEW_PARAM = 'wu_stock_preview'

/** おちゃのこの商品ページ /product/{管理番号} から管理番号を取る。 */
export function productCodeFromPath(pathname: string): number | null {
  const m = /^\/product\/(\d+)\/?$/.exec(pathname)
  return m ? Number(m[1]) : null
}

function waitFor(selector: string, tries: number, intervalMs: number): Promise<Element | null> {
  return new Promise((resolve) => {
    let n = 0
    const tick = () => {
      const el = document.querySelector(selector)
      if (el || ++n >= tries) return resolve(el)
      setTimeout(tick, intervalMs)
    }
    tick()
  })
}

export default async function stockCheckPreview(): Promise<void> {
  const siteId = window.wu?.siteInfoId
  const code = productCodeFromPath(location.pathname)
  if (!siteId || code === null) return

  const r = await fetch(`${API}?productCode=${code}&siteInfoId=${siteId}`, { cache: 'no-store' })
  const html = await r.text()

  const box = document.createElement('div')
  box.setAttribute('data-wu-stock-preview', '')
  box.style.cssText = 'border:2px dashed #c00;padding:4px;margin:10px 0'
  box.innerHTML =
    `<div style="color:#c00;font-size:11px;font-weight:bold">【新】front.workup-system.com/api/stock-check（検証表示。${r.status}${html ? '' : '・空応答'}）</div>` +
    html

  // 旧が差し込むまで待つ（#zk-inq と同じ 300ms × 20 回）
  const old = await waitFor('.stockInfo', 20, 300)
  const anchor =
    old ??
    document.querySelector('.product_info_wrapper') ??
    document.querySelector('.detail_section.box_both_ends_space.return') ??
    document.querySelector('.detail_cart_box')
  if (!anchor) {
    console.warn('[wu] stock-check-preview: 差し込み先が見つかりません')
    return
  }
  anchor.insertAdjacentElement('afterend', box)
}
